module.exports = {
	// 留言板
	msg:{
		msg:'在线留言',
		tit:'留言板',
		holder1:'请在此输入留言信息，我们会尽快与您联系。（必填）',
		holder2:'姓名（必填）',
		holder3:'电话（必填）',
		holder4:'邮箱（必填）',
		holder5:'公司',
		btn:'发送'
	},
	// 头部
	header: {
		search: {
			placeholder: '搜索信息',
			title:'您在找什么？'
		}
	},
	homeTxt:'首页',
	// 导航
	nav:{
		list:[{
			url:'/',
			name:'首页'
		},{
			url:'',
			name:'公司介绍',
			sub:[{
				url:'/company',
				name:'公司简介'
			},{
				url:'/news',
				name:'公司新闻'
			},{
				url:'/team',
				name:'管理团队'
			},{
				url:'/honor',
				name:'公司资质'
			},{
				url:'/partner',
				name:'合作伙伴'
			}]
		},{
			url:'',
			name:'服务',
			sub:[{
				url:'/department',
				name:'医学事务'
			},{
				url:'/pharmacovigilance',
				name:'药物警戒'
			},{
				url:'/statistics',
				name:'生物统计'
			},{
				url:'/management',
				name:'数据管理'
			},{
				url:'/program',
				name:'统计编程'
			},{
				url:'/case',
				name:'公司案例'
			}]
		},{
			url:'',
			name:'资源中心',
			sub:[{
				url:'/report',
				name:'行业培训'
			},{
				url:'/share',
				name:'知识分享'
			}]
		},{
			url:'',
			name:'联系我们',
			sub:[{
				url:'/contactus',
				name:'联系方式'
			},{
				url:'/recruit',
				name:'招聘信息'
			}]
		}]
	},
	// 底部
	footer: {
		qrtxt:'关注我们'
	},
	// 当前位置
	cur:{

	},
	// 页码
	pages: {
		prev: '上一页',
		next: '下一页'
	},

	// 首页
	home: {
		// 关于我们
		aboutUS: {
			title: '关于我们',
			btn: '查看更多'
		},
		ourTeam: {
			title: '我们的团队',
			btn: '查看更多'
		},
		serve:{
			title:'服务'
		},
		achievement:{
			title:'成就',
			btn: '查看更多'
		},
		contact:{
			title:'联系我们'
		}
	},
	// 联系我们
	contactUs: {
		info:{
			tit:'联系我们',
			adr:'地址',
			pos:'邮政编码',
			tel:'电话',
			fax:'穿着',
			email:'邮箱',
		},
		title: '办公地点',
		seemap:'查阅地图'
		
	},
	// 招聘
	recruit: {
		title: '工作职责',
		placeholder:'职位',
		btn:'申请',
		desc:'暂无数据',
		loc:'请选择区域',
		dept:'请选择部门',

		btn1:'上传简历',

		pop:{
			tit:'投递简历',
			t1:'姓　 名',
			holder1:'请输入您的姓名',
			t2:'电　 话',
			holder2:'请输入您的电话',
			t3:'邮　 箱',
			holder3:'请输入您的邮箱',
			t4:'附　 件',
			holder4:'请上传您的简历附件',
			t5:'岗　 位',
			holder5:'请输入您应聘的岗位',
			t6:'地　 点',
			holder6:'请输入您应聘的城市',
			tip:'支持格式：.doc .docx，pdf,单个文件不能超过5M',
			btn:'确认发送'
		}
		
	},
	// 公司简介
	company:{
		tit:'了解艾科曼',
		tit1:'发展历程',
		tit2:'AMIT业务范围',
		tit3:'企业文化',
		tit4:'公司照片',
		tit5:'我们的愿景',
	},

	// 知识分享
    share: {
        btn: '查看详情',
       
    },
	// 公司案例
    case: {
        tit: '公司案例',
       
    },

    // 搜索结果
    result:{
      txt:'的搜索结果'
    }

	

}